import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from '@core/services/seo.service';
import { environment } from '@environment';
import { TranslatedJobUrls } from '@features/directories/translated-urls';
import { JobLanding } from '@models/seo/job-landing';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { LinkRel, TypesEnum } from '@routing/directories/directories-routing.enum';
import { GetCities } from '@store/seo/seo.actions';
import { SeoState } from '@store/seo/seo.state';
import { buildPath, buildUrl } from '@wizbii/angular-utilities';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-jobs-cities',
  templateUrl: './jobs-cities.component.html',
  styleUrls: ['./jobs-cities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsCitiesComponent implements OnInit, OnDestroy {
  @Select(SeoState.cities)
  cities$: Observable<JobLanding[]>;

  private metaElements: HTMLMetaElement[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly seoService: SeoService,
    private readonly store: Store,
    private readonly metaService: Meta
  ) {}

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this)).subscribe((data) => {
      this.seoService.createLinkForCanonicalURL(data.lang, TypesEnum.city);
    });

    this.store.dispatch(new GetCities(environment.locale));

    this.metaElements = [
      this.metaService.addTag({
        name: 'robots',
        content: 'index,follow',
      }),
    ];
  }

  ngOnDestroy(): void {
    this.seoService.removeLinkWithRel(LinkRel.Canonical);

    this.metaElements.forEach((meta) => {
      this.metaService.removeTagElement(meta);
    });
  }

  buildTranslatedUrl(slug: string): string {
    return buildUrl(buildPath(TranslatedJobUrls[environment.lang]), {
      id: slug,
    });
  }

  trackBySlug(_: any, landing: JobLanding): string {
    return landing.slug;
  }
}
